import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "./components/header";
import SignupForm from "./components/signupForm";
// import "./App.css"
import Home from "./components/home";
import React, { Fragment } from 'react';
import Login from "./components/login";
import Otp from './components/otp';
import BDetails from "./components/BDetails";
import IDetails from "./components/IDetails";
import Influencer from "./components/influenceSearch";
import Card from "./components/card";
import BHomeCard from "./components/BHomeCard";
import BHomepage from "./components/BHomepage";
import ViewInfluencer from "./components/viewInfluencer";
import ChatCard from "./components/chatCard";
import Chat from "./components/chat";
import ChatNameList from "./components/ChatNameList";
import ChatNameListCard from "./components/ChatNameListCard";
import Pricing2 from "./components/Pricing2";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function App() {
  return (
    <div className="App">
      <header className="App-header">

        <BrowserRouter>
          <Routes>
            <Route exact path="/" element={<Home />} />
            {/* <Route exact path="/signup" render={() =>
              <Fragment>
                <SignupForm />
              </Fragment>
            } /> */}
            {/* <Route exact path="/signup" element={<><Header/><SignupForm /></>} /> */}
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/infsearch" element={<Influencer />} />
            <Route exact path="/card" element={<Card />} />
            <Route exact path="/otp" element={<Otp />} />
            <Route exact path="/signup" element={<><SignupForm /></>} />
            <Route exact path="/brand-details" element={<BDetails />} />
            <Route exact path="/influencer-details" element={<IDetails />} />
            <Route exact path="/influencer-search" element={<Influencer />} />
            <Route exact path="/bhomecard" element={<BHomeCard />} />
            <Route exact path="/bhomepage" element={<BHomepage />} />
            <Route exact path="/view-influencer" element={<ViewInfluencer />} />
            <Route exact path="/chat-card" element={<ChatCard />} />
            <Route exact path="/chat" element={<Chat />} />
            <Route exact path="/pricing" element={<Pricing2 />} />
            <Route exact path="/chat-name-list" element={<ChatNameList />} />
            <Route exact path="/chat-name-list-card" element={<ChatNameListCard />} />

            <Route exact path="/view-profile" element={<ViewInfluencer />} />

          </Routes>
        </BrowserRouter>
      </header>
      <div>
        <ToastContainer />
      </div>
    </div>
  );
}

export default App;
